export const SIGN_UP_STEP_SLUGS = [
  "dane-logowania",
  "dane-osobowe",
  "adres-i-kontakt",
] as const;

export const VOUCHER_PURCHASE_STEP_SLUGS = [
  "dane-kupujacego",
  "podsumowanie",
  "potwierdzenie",
] as const;

export const RACE_REGISTRATION_STEP_SLUGS = [
  "dane-osobowe",
  "dane-biegu",
  "dodatki",
  "podsumowanie",
  "potwierdzenie",
] as const;

export const SWITCH_RACE_STEP_SLUGS = [
  "dane-osobowe",
  "dane-biegu",
  "dodatki",
  "podsumowanie",
  "potwierdzenie",
] as const;

export const EDIT_ENTRY_STEP_SLUGS = [
  "dane-osobowe",
  "dane-biegu",
  "dodatki",
  "podsumowanie",
  "potwierdzenie",
] as const;

export type RaceRegistrationMode = "zapis" | "realizacja-vouchera";

export const stepIndexFromSlug = <T extends readonly string[]>(
  slugs: T,
  slug: string | undefined,
): number => {
  const index = slugs.indexOf(slug as T[number]);
  return index === -1 ? 0 : index;
};

export const isStepSlug = (
  slugs: readonly string[],
  slug: string | undefined,
): boolean => slug !== undefined && slugs.includes(slug);

/** Strona wydarzenia na domenie głównej - lista biegów tego wydarzenia. */
export const eventPath = (slug: string) => `/${slug}`;

export const signUpStepPath = (step: number) =>
  `/rejestracja/${SIGN_UP_STEP_SLUGS[step] ?? SIGN_UP_STEP_SLUGS[0]}`;

export const purchaseModePath = (raceId: number, redeemVoucher = false) =>
  `/biegi/${raceId}/wybor-zakupu${redeemVoucher ? "/realizacja-vouchera" : ""}`;

export const voucherPurchaseStepPath = (raceId: number, step: number) =>
  `/biegi/${raceId}/zakup-vouchera/${VOUCHER_PURCHASE_STEP_SLUGS[step] ?? VOUCHER_PURCHASE_STEP_SLUGS[0]}`;

const appendTransactionId = (path: string, transactionId?: string) =>
  transactionId ? `${path}/${encodeURIComponent(transactionId)}` : path;

export const voucherPurchaseConfirmationPath = (
  raceId: number,
  transactionId?: string,
) => appendTransactionId(voucherPurchaseStepPath(raceId, 2), transactionId);

export const raceRegistrationStepPath = (
  raceId: number,
  mode: RaceRegistrationMode,
  step: number,
) => `/biegi/${raceId}/${mode}/${RACE_REGISTRATION_STEP_SLUGS[step] ?? RACE_REGISTRATION_STEP_SLUGS[0]}`;

export const raceRegistrationConfirmationPath = (
  raceId: number,
  mode: RaceRegistrationMode,
  transactionId?: string,
) => appendTransactionId(
  raceRegistrationStepPath(raceId, mode, 4),
  transactionId,
);

export const switchRaceStepPath = (
  sourceRaceId: number,
  targetRaceId: number,
  step: number,
) => `/zmiana-biegu/${sourceRaceId}/${targetRaceId}/${SWITCH_RACE_STEP_SLUGS[step] ?? SWITCH_RACE_STEP_SLUGS[0]}`;

export const switchRaceConfirmationPath = (
  sourceRaceId: number,
  targetRaceId: number,
  transactionId?: string,
) => appendTransactionId(
  switchRaceStepPath(sourceRaceId, targetRaceId, 4),
  transactionId,
);

export const editEntryStepPath = (raceId: number, step: number) =>
  `/biegi/${raceId}/edycja-zapisu/${EDIT_ENTRY_STEP_SLUGS[step] ?? EDIT_ENTRY_STEP_SLUGS[0]}`;

export const editEntryConfirmationPath = (
  raceId: number,
  transactionId?: string,
) => appendTransactionId(editEntryStepPath(raceId, 4), transactionId);
